var map = {
	"./business-head/business-head.module.ngfactory": [
		"./src/app/platform/business-head/business-head.module.ngfactory.js",
		"business-head.module"
	],
	"./cad/cad.module.ngfactory": [
		"./src/app/platform/cad/cad.module.ngfactory.js",
		"cad.module"
	],
	"./calender/calender.module.ngfactory": [
		"./src/app/platform/calender/calender.module.ngfactory.js",
		"calender.module"
	],
	"./category/category/category.module.ngfactory": [
		"./src/app/platform/category/category/category.module.ngfactory.js",
		"category.module"
	],
	"./customer/customer.module.ngfactory": [
		"./src/app/platform/customer/customer.module.ngfactory.js",
		"customer.module"
	],
	"./designer/designer.module.ngfactory": [
		"./src/app/platform/designer/designer.module.ngfactory.js",
		"designer.module"
	],
	"./emicalculator/emicalculator.module.ngfactory": [
		"./src/app/platform/emicalculator/emicalculator.module.ngfactory.js",
		"emicalculator.module"
	],
	"./finance/finance.module.ngfactory": [
		"./src/app/platform/finance/finance.module.ngfactory.js",
		"finance.module"
	],
	"./general-manager/general-manager.module.ngfactory": [
		"./src/app/platform/general-manager/general-manager.module.ngfactory.js",
		"general-manager.module"
	],
	"./lead/lead.module.ngfactory": [
		"./src/app/platform/lead/lead.module.ngfactory.js",
		"lead.module"
	],
	"./modularproductscatalogue/modularproductscatalogue.module.ngfactory": [
		"./src/app/platform/modularproductscatalogue/modularproductscatalogue.module.ngfactory.js",
		"modularproductscatalogue.module"
	],
	"./order-manager/order-manager.module.ngfactory": [
		"./src/app/platform/order-manager/order-manager.module.ngfactory.js",
		"order-manager.module"
	],
	"./organisation/organisation.module.ngfactory": [
		"./src/app/platform/organisation/organisation.module.ngfactory.js",
		"organisation.module"
	],
	"./presentation/presentation.module.ngfactory": [
		"./src/app/platform/presentation/presentation.module.ngfactory.js",
		"presentation.module"
	],
	"./priceconfigurator/priceconfigurator.module.ngfactory": [
		"./src/app/platform/priceconfigurator/priceconfigurator.module.ngfactory.js",
		"priceconfigurator.module"
	],
	"./profile/profile.module.ngfactory": [
		"./src/app/platform/profile/profile.module.ngfactory.js",
		"profile.module"
	],
	"./project/project.module.ngfactory": [
		"./src/app/platform/project/project.module.ngfactory.js",
		"project.module"
	],
	"./quotation/quotation.module.ngfactory": [
		"./src/app/platform/quotation/quotation.module.ngfactory.js",
		"quotation.module"
	],
	"./referral/referral.module.ngfactory": [
		"./src/app/platform/referral/referral.module.ngfactory.js",
		"referral.module"
	],
	"./salesmanager/salesmanager.module.ngfactory": [
		"./src/app/platform/salesmanager/salesmanager.module.ngfactory.js",
		"salesmanager.module"
	],
	"./scheduler/scheduler.module.ngfactory": [
		"./src/app/platform/scheduler/scheduler.module.ngfactory.js",
		"scheduler.module"
	],
	"./sitesupervisor/sitesupervisor.module.ngfactory": [
		"./src/app/platform/sitesupervisor/sitesupervisor.module.ngfactory.js",
		"sitesupervisor.module"
	],
	"./testimonial/testimonial.module.ngfactory": [
		"./src/app/platform/testimonial/testimonial.module.ngfactory.js",
		"testimonial.module"
	],
	"./user-roles/user-roles.module.ngfactory": [
		"./src/app/platform/user-roles/user-roles.module.ngfactory.js",
		"user-roles.module"
	],
	"app/account/account.module.ngfactory": [
		"./src/app/account/account.module.ngfactory.js",
		"account.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main